module.exports = __webpack_public_path__ + "3cfb6c9a.svg";